import { FulfillmentMethod, Session } from "@insite/client-framework/Services/SessionService";
import { WarehouseModel } from "@insite/client-framework/Types/ApiModels";

export enum FulfillmentMethodExtend {
    Delivery = "Delivery",
    ShipToStore = "ShipToStore",
}

export const StoreFulfillmentMethod = { ...FulfillmentMethod, ...FulfillmentMethodExtend };

export type StoreSession = Session & {
    warehouse: WarehouseModel;
};
